
import React, { useState, useEffect } from "react";
import { Global } from "../helpers/Global";

export const CentrosEmpleado = () => {
  const [clientes, setClientes] = useState([]);
  const [centros, setCentros] = useState([]);
  const [mostrarCentrosDeCliente, setMostrarCentrosDeCliente] = useState(null);

  useEffect(() => {
    fetchClientes();
    fetchCentros();
  }, []);

  const fetchClientes = async () => {
    try {
      const res = await fetch(`${Global.url}clientes`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const data = await res.json();
      setClientes(data);
    } catch (error) {
      console.error("Error al obtener clientes:", error);
    }
  };

  const fetchCentros = async () => {
    try {
      const res = await fetch(`${Global.url}centros`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const data = await res.json();
      setCentros(data);
    } catch (error) {
      console.error("Error al obtener centros:", error);
    }
  };

  const abrirEnGPS = (lat, lng) => {
    if (lat && lng) {
      const url = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
      window.open(url, "_blank");
    } else {
      alert("Este centro no tiene coordenadas asignadas.");
    }
  };

  const toggleCentros = (clienteId) => {
    setMostrarCentrosDeCliente((prev) => (prev === clienteId ? null : clienteId));
  };

  return (
    <div className="tabla-clientes">
      <h2>Centros de Trabajo</h2>
      <table className="tabla-listado-clientes">
        <thead>
          <tr>
            <th>Cliente</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {clientes.map((cliente) => (
            <React.Fragment key={cliente.id}>
              <tr>
                <td>{cliente.nombre}</td>
                <td>
                  <button className="btn-secundario" onClick={() => toggleCentros(cliente.id)}>
                    {mostrarCentrosDeCliente === cliente.id ? "Ocultar Centros" : "Mostrar Centros"}
                  </button>
                </td>
              </tr>

              {mostrarCentrosDeCliente === cliente.id && (
                <tr>
                  <td colSpan="2" style={{ padding: 0 }}>
                    <table className="subtabla-centros">
                      <thead>
                        <tr>
                          <th>Centro</th>
                          <th>Acción</th>
                        </tr>
                      </thead>
                      <tbody>
                        {centros
                          .filter((c) => c.cliente_id === cliente.id)
                          .map((centro) => (
                            <tr key={centro.id}>
                              <td>{centro.nombre}</td>
                              <td>
                                <button
                                  className="btn-secundario"
                                  onClick={() =>
                                    abrirEnGPS(centro.latitud, centro.longitud)
                                  }
                                >
                                  Ver en GPS
                                </button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};
